import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LotExpirationWarningDialogData } from '../../models/dialog.model';

@Component({
  selector: 'app-lot-expiration-warning-dialog',
  templateUrl: './lot-expiration-warning-dialog.component.html',
  styleUrl: './lot-expiration-warning-dialog.component.scss'
})
export class LotExpirationWarningDialogComponent {
  readonly dialogRef = inject(MatDialogRef<LotExpirationWarningDialogComponent>);
  readonly data = inject<LotExpirationWarningDialogData>(MAT_DIALOG_DATA);

  confirm(): void { this.dialogRef.close(true); }
  cancel(): void { this.dialogRef.close(false); }
}
